export default function UserPreferencesCardDesktopAppSettings() {
	return null;
}
